import request from "../../util/request";

export function payLevel() {
    return request({
        url: '/api-admin/user/pay/level',
        method: 'get',
    })
}

export function pay(model) {
    return request({
        url: '/api-admin/user/pay/pay',
        method: 'post',
        data: model
    })
}